var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { convertTextToPaths, drawCutLine } from './CanvasHelpers';
import { mmToPixels } from './DecalEditorCanvasSizing';
export const copyCanvasForSvgExport = (fabricCanvas, canvasSize, withCutLines) => __awaiter(void 0, void 0, void 0, function* () {
    let newCanvas = null;
    const cloneOptions = [
        'objects',
        'id',
        'className',
        'spotfill',
        'spotstroke',
        'viewportTransform',
        'backgroundColor',
        'width',
        'height',
        'clipPath',
        'renderOnAddRemove',
        'charSpacing',
        'lineHeight',
        'lineHeightMultiplier',
        '_charBounds',
    ];
    try {
        newCanvas = yield new Promise((resolve, reject) => {
            fabricCanvas
                .clone(cloneOptions)
                .then((clonedCanvas) => {
                if (!clonedCanvas) {
                    reject(new Error('Failed to clone canvas'));
                }
                else {
                    resolve(clonedCanvas);
                }
            })
                .catch((error) => {
                reject(error);
            });
        });
        if (!newCanvas) {
            throw new Error('Cloned canvas is null');
        }
        for (const obj of newCanvas.getObjects()) {
            if (obj.type === 'textbox' || obj.type === 'text') {
                yield convertTextToPaths(obj, newCanvas);
                newCanvas.remove(obj);
            }
        }
        const svg = newCanvas.toSVG({
            width: mmToPixels(canvasSize.width).toString(),
            height: mmToPixels(canvasSize.height).toString(),
        });
        if (withCutLines) {
            return yield drawCutLine(svg);
        }
        return svg;
    }
    catch (error) {
        console.error('Error exporting canvas to SVG:', error);
        return null;
    }
    finally {
        if (newCanvas) {
            try {
                yield newCanvas.dispose();
            }
            catch (disposeError) {
                console.error('Error disposing newCanvas:', disposeError);
            }
        }
    }
});
